import $ from 'jquery';
import 'select2/dist/js/select2';
import Select2 from 'v-select2-component';

$.fn.select2.defaults.set('theme', 'bootstrap');

Select2.methods.focus = function focus() {
  this.select2.select2('focus');
};
Select2.methods.open = function focus() {
  this.select2.select2('open');
};

export default Select2;
